/* eslint-disable lines-between-class-members */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { isEmpty } from '@ember/utils';
import { inject as service } from '@ember/service';
import dispatcher from 'mewe/dispatcher';

export default class FollowButton extends Component {
  @service account;

  @tracked actionInProgress = false;

  get user() {
    return this.args.user;
  }

  get showFollowButton() {
    return !this.user.isMe && this.user.publicLinkId; // checking publicLinkId to know if profile was fetched
  }

  get isFollowingMe() {
    return this.user.follower && !this.isFollowRequestSent;
  }

  get isUserFollowedByMe() {
    return this.user.following;
  }

  get isFollowRequestSent() {
    return !isEmpty(this.user.followRequestSent);
  }

  get followOptions() {
    return {
      user: this.user,
      groupId: this.args.group?.id,
      eventId: this.args.event?.id,
    };
  }

  @action
  followUser() {
    this.actionInProgress = true;

    const options = this.followOptions;
    options.alwaysCb = () => {
      this.actionInProgress = false;
    };

    dispatcher.dispatch('contact', 'followUser', options);
  }

  @action
  unfollowUser() {
    this.actionInProgress = true;

    const options = this.followOptions;
    options.alwaysCb = () => {
      this.actionInProgress = false;
    };

    dispatcher.dispatch('contact', 'unfollowUser', options);
  }

  @action
  cancelRequestSent() {
    this.actionInProgress = true;

    const alwaysCb = () => {
      this.actionInProgress = false;
    };

    dispatcher.dispatch('contact', 'cancelRequestSent', this.followOptions, null, alwaysCb);
  }
}
